export default __webpack_public_path__ + "static/media/AvenirNextCyr-Light.478f0acd.ttf";